import React from 'react';
import { Icon } from '@app/src/common/Icon';
import {
  InputTextWrapper,
  IconLoading,
  ErrorMessage,
  Wrapper
} from './styled';

interface Props {
  type?: string;
  loading?: boolean;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  handleChange?: Function;
  handleChangeInput?: Function;
  handleBlur?: Function;
  error?: string;
  value?: string;
  name?: string;
}

export const Input: React.FC<Props> = ({
  type,
  loading,
  maxLength,
  disabled,
  placeholder,
  handleChange,
  handleChangeInput,
  handleBlur,
  error,
  value,
  name
}) => {

  const handleChangeProp = (e) => {
    handleChangeInput && handleChangeInput(e);
    handleChange && handleChange(e.target.value);
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  return (
    <React.Fragment>
      <Wrapper>
        <InputTextWrapper
          name={name}
          type={type !== 'number' ? 'text' : 'number'}
          placeholder={placeholder}
          value={value}
          onChange={handleChangeProp}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          maxLength={maxLength}
          disabled={disabled}
          error={error}
        />
          { loading && <IconLoading><Icon data-name='icon-circle' fill='#ccc' width="17" height="17" /></IconLoading> }
      </Wrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </React.Fragment>
)};
